import { createStore } from "solid-js/store";
import { useNavigate } from "@solidjs/router";
import { useAuthentication } from "../../context/auth";
import { useApplication } from "@/context/app";
import authToken from "../../context/token";
import { login } from "../../requests/auth";
import { createSignal } from "solid-js";

export default function useLogin() {
  const [loading, setLoading] = createSignal(false);
  const [form, setForm] = createStore({
    identity: "",
    password: "",
  });

  const { setCurrentUser } = useAuthentication();
  const { setAccessToken, setRefreshToken } = authToken;
  const { successToast, errorToast } = useApplication();
  const navigate = useNavigate();

  const onFormInput = (name, value) => {
    setForm(name, value);
  };

  const onSubmit = async (ev) => {
    ev.preventDefault();
    await onLogin();
  };

  const onLogin = async () => {
    setLoading(true);
    try {
      const response = await login({
        ...form
      });

      setCurrentUser(response.user);
      setAccessToken(response.accessToken);
      setRefreshToken(response.refreshToken);
      successToast(response.message);
      navigate("/home", { replace: true });
    } catch (error) {
      errorToast(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    form,
    onSubmit,
    onLogin,
    onFormInput,
  };
}
